export const DIRECTORS = 'md_directors_GLOBAL';